import { defaultResumeData, idSchema, resumeDataSchema } from "@reactive-resume/schema";
import { dateSchema } from "@reactive-resume/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import { userSchema } from "../user";
import { coverLetterSchema } from "../cover-letter";

export const jobSchema = z.object({
  id: idSchema,
  description: z.string(),
  resumeId: idSchema,
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

export const resumeSchema = z.object({
  id: idSchema,
  title: z.string(),
  slug: z.string(),
  data: resumeDataSchema.default(defaultResumeData),
  visibility: z.enum(["private", "public"]).default("private"),
  locked: z.boolean().default(false),
  userId: idSchema,
  user: userSchema.optional(),
  job: jobSchema.optional().nullable(),
  coverLetter: coverLetterSchema.optional().nullable(),
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

export class ResumeDto extends createZodDto(resumeSchema) {}
export class JobDto extends createZodDto(jobSchema) {}

export type { CoverLetterDto } from "../cover-letter";
